import { render } from "./MultiSelect.vue?vue&type=template&id=cedfb2de&scoped=true&ts=true"
import script from "./MultiSelect.vue?vue&type=script&lang=ts"
export * from "./MultiSelect.vue?vue&type=script&lang=ts"

import "./MultiSelect.vue?vue&type=style&index=0&id=cedfb2de&lang=scss&scoped=true"

import exportComponent from "/var/www/prod_sara2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cedfb2de"]])

export default __exports__